import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import { getRef } from '../../../../config/firebase';
import { updateLastUpdatedTimestamp } from '../../../../utils';
import Loader from '../../../../components/Loader';
import MarkdownEditor from '../../components/MarkdownEditor';

import './style.css';

class BellOfMindfulness extends Component {
  constructor(props) {
    super(props);

    this.state = {
      switch_title: '',
      content: '',
      loading: true,
    }

    this.settingsRef = getRef('/content/bellOfMindfulness');

    this.handleMarkdownEditorChange = this.handleMarkdownEditorChange.bind(this)
    this.handleTextfieldChange = this.handleTextfieldChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.settingsRef.on('value', (snapshot) => {
      if ( snapshot.val() ) {
        let data = snapshot.val();
        this.setState({
          switch_title: data.switch_title,
          content: data.content,
        });
      }
      this.setState({loading: false});
    });
  }

  componentWillUnmount() {
    this.settingsRef.off();
  }

  handleTextfieldChange(event) {
    let value = event.target.value;
    let name = event.target.name;
    this.setState({[name]: value});
  }

  handleMarkdownEditorChange(value) {
    this.setState({content: value});
  }

  handleSubmit(event) {
    event.preventDefault();

    const data = {
      switch_title: this.state.switch_title,
      content: this.state.content,
    }

    this.settingsRef.update(data, () => {
      updateLastUpdatedTimestamp();
      this.setState({loading: false});
    });
    this.setState({loading: true});
  }

  render() {
    return (
      <div className="form-wrapper">
        <form onSubmit={this.handleSubmit}>
          <div className="loading-wrapper" style={{display: this.state.loading ? 'block' : 'none'}}>
            <Loader />
          </div>

          <MarkdownEditor
            title='Page content'
            onChange={this.handleMarkdownEditorChange}
            value={this.state.content}
          />
          <TextField
            fullWidth
            label="Switch title"
            name="switch_title"
            required
            value={this.state.switch_title}
            onChange={this.handleTextfieldChange}
          />
          <div className="text-right" style={{marginTop: 20}}>
            <Button variant="raised" color="primary">Update</Button>
          </div>
        </form>
      </div>
    )
  }
}

export default BellOfMindfulness;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/BellOfMindfulness/index.js